
import {Component, Prop, Vue} from "vue-property-decorator";
import login from "@/components/auth/login.vue";
import {IMenuItem} from "./types/menu.interface";
import {namespace} from "vuex-class";
import "@aws-amplify/ui-vue";
import authService from "@/services/auth.service";
import panierService from "@/services/panier.service";
import userService from "@/services/user.service";
import Contact from "@/components/auth/Contact.vue";
import frontService from "@/services/front.service";

const panierModule = namespace("panierModule");
const userModule = namespace("userModule");

@Component({
  components: {login, Contact}
})
export default class App extends Vue {
  @userModule.State
  public user: any;
  @userModule.State
  public role;

  @userModule.State
  public itemName;

  @userModule.State
  public path;

  @userModule.State
  public editFromBasket;

  @userModule.Mutation
  public setEditFromBasket;

  @userModule.Mutation
  public resetPath;

  @userModule.Mutation
  public setPath;

  @userModule.Action
  public getUser;
  @userModule.Action
  public getRoles;

  @panierModule.Action
  public setCountField!: (count: number) => void;
  @panierModule.State
  public count!: number;

  @panierModule.Mutation
  public setItemCat!: (itemCat: string) => void;

  @panierModule.State
  public itemCat!: string;

  @Prop() history: boolean;

  logging = false;
  isLoading = false;
  dialogPreview = false;
  item;
  buttonSelected = '';

  public vm = new Vue({
    data: {
      login: false,
      contact: false,
      snackbar: false,
      user_link: [
        [
          /*
              {
                  title: 'Paramètres utilisateur',
                  route: { name: 'User',  query: { page: 0 }}
              },
             */
          {
            title: 'Mes documents',
            route: {name: 'User', query: {page: 0}}
          },
          {
            title: 'Historique des commandes',
            route: {name: 'User', query: {page: 1}}
          },
          /*
              {
                  title: 'Facturation',
                  route: { name: 'User',  query: { page: 3 }}
              }
              */
        ],
        [
          {
            title: 'Mentions légales',
            route: 'https://www.infolegale.fr/mentions-legales'
          },
          {
            title: 'CGV - CGU',
            route: 'https://www.infolegale.fr/conditions-generales-dutilisation'
          }
        ]

      ],
      itemsMenu: [
        {
          name: "Dashboard",
          route: "/",
          title: "Tableau de bord",
          hidden: false,
          url: require('@/assets/tableau-de-bord-24px-outline.svg'),
          isActive: true
        },
        {
          name: "Comptage",
          route: "/comptage",
          title: "Comptage",
          hidden: false,
          url: require('@/assets/comptage-24px-outline.svg'),
        },
        {
          name: "Enrichissement",
          route: "/enrichissement",
          title: "Enrichissement",
          hidden: false,
          url: require('@/assets/enrichissement-24px-outline.svg'),
        },
        {
          name: "Qualite",
          route: "/qualite",
          title: "Mise en qualité",
          hidden: false,
          url: require('@/assets/mise-en-qualite-24px-outline.svg'),
        }
      ],
    },
    methods: {
      onClickOutside() {
        this.contact = false;
      },
      checkOnHidden() {
        if (this.role != undefined) {
          this.itemsMenu[0].hidden = !this.role.app_dig;
          this.itemsMenu[1].hidden = !this.role.app_dig_comptage || !this.role.app_dig;
          this.itemsMenu[2].hidden = !this.role.app_dig_enrichissement || !this.role.app_dig;
          this.itemsMenu[4].hidden = !this.role.app_dig_sirenisation || !this.role.app_dig;
        }
      },
      contactDisplay() {
        this.snackbar = false;
        this.contact_errors = [];
        this.contact = !this.contact;
      },
      uploadFile() {
        if (
            this.file &&
            typeof this.file !== "undefined"
        ) {
          this.uploadingFile = true;
        }
      },
      displaySnackBar() {
        this.snackbar = true;
      }
    }
  });

  created() {
    if (!this.vm.login) {
      this.isLoading = true;
      setTimeout(() => this.login());
    }
  }

  mounted() {
    this.isLoading = true;
    this.isLogged();
  }

  isLogged(): boolean {
    if (localStorage.getItem("tokenJWT") != null) {
      this.initUser();
      this.vm.login = true;
      return true
    }
    return false;
  }


  login() {
    if (this.logging === false) {
      this.logging = true;
      if (localStorage.getItem("tokenJWT") != null) {
        this.initUser();
        this.vm.login = true;
          this.logging = false;
        if (localStorage.getItem("redirect")) {
            const redirectRoute = JSON.parse(localStorage.getItem("redirect"));
            localStorage.removeItem("redirect");
            if (redirectRoute.path !== '/') {
                this.$router.push({path: redirectRoute.path, query: redirectRoute.query});
            }
        }
      } else {
        if (this.$route.query.code != undefined) {
          userService.getJWT(this.$route.query.code.toString()).then(
              result => {
                  userService.setUser(result.data);
                  this.initUser();
                  this.logging = false;
                  if (localStorage.getItem("redirect")) {
                      const redirectRoute = JSON.parse(localStorage.getItem("redirect"));
                      localStorage.removeItem("redirect");
                      if (redirectRoute.path !== '/') {
                          this.$router.push({path: redirectRoute.path, query: redirectRoute.query});
                      }
                  }
              },
              error => {
                console.log(error);
              });
        } else {
          const uri = window.location.href.split('?');
          const params = {};
          if(uri.length == 2) {
              const vars = uri[1].split('&');
              vars.forEach(function(v) {
                  const tmp = v.split('=');
                  if(tmp.length == 2)
                      params[tmp[0]] = tmp[1];
              });
          }
          const route = {path: window.location.pathname, query: params};
          localStorage.setItem('redirect', JSON.stringify(route));
          setTimeout(() => location.replace(process.env.VUE_APP_AUTH_URI + '/oauth/v2/auth?response_type=code&state=&client_id=' + process.env.VUE_APP_CLIENT_ID + '&scope=openid&redirect_uri=' + process.env.VUE_APP_REDIRECT_URI));
          this.logging = false;
          this.isLoading = false;
        }
      }
    }

  }

  selectedMenuItem: IMenuItem = this.vm.itemsMenu.filter(item => {
    return item.name == this.$route.name;
  })[0];

  simpleRedirection(){
    switch(this.buttonSelected) {
      case 'panier':
        this.$router.push({path: '/panier'});
        this.setItemCat("");
        break;
      case 'documents':
        this.$router.push({path: '/user?page=0'});
        this.setItemCat("");
        break;
      case 'historique':
        this.$router.push({path: '/user?page=1'});
        this.setItemCat("");
        this.history=true;
        break;
      case 'mentions':
        window.location.replace("https://www.infolegale.fr/mentions-legales/");
        break;
      case 'cgvcgu':
        window.location.replace("https://www.infolegale.fr/conditions-generales-dutilisation/");
        break;
      case 'logout':
        this.logout();
        break;
      default:
    }
    this.buttonSelected='';
    this.setEditFromBasket(false);
    this.dialogPreview=false;
  }

  redirectFromPreview() {
    this.selectedMenuItem = this.item;
    if(!this.buttonSelected){
      if(this.selectedMenuItem.name=='Dashboard') {
        this.$router.push({path: '/'});
      } else {
        this.$router.push({path: '/' + this.selectedMenuItem.name});
      }
    } else {
      this.setItemCat("");
      this.simpleRedirection();
    }
    this.dialogPreview=false;
    this.setPath('');
    this.setEditFromBasket(false);
    this.item = '';
  }

  redirect(item: IMenuItem){
    this.selectedMenuItem = item;
    this.$router.push({path: item.route});
    this.item = '';
  }

  getPath(item: IMenuItem) {
    this.item = item;
    if(this.path != ''){
      if(this.path != item.name) {
        this.dialogPreview = true;
      }
    }
  }

  handleSelectItem(item: IMenuItem) {
    if(this.editFromBasket) {
      this.dialogPreview = true;
      this.setPath('');
    } else {
      this.selectedMenuItem = item;
      this.setPath('');
      this.setEditFromBasket(false);
    }
  }

  setRoles() {
    Vue.set(this.vm.itemsMenu, 0,
        {
          name: "Dashboard",
          route: "/",
          title: "Tableau de bord",
          hidden: !this.role.app_dig,
          url: require('@/assets/tableau-de-bord-24px-outline.svg'),
        });
    Vue.set(this.vm.itemsMenu, 1,
        {
          name: "Comptage",
          route: "/comptage",
          title: "Comptage",
          hidden: !this.role.app_dig_comptage || !this.role.app_dig,
          url: require('@/assets/comptage-24px-outline.svg'),
        });
    Vue.set(this.vm.itemsMenu, 2,
        {
          name: "Enrichissement",
          route: "/enrichissement",
          title: "Enrichissement",
          hidden: !this.role.app_dig_enrichissement || !this.role.app_dig,
          url: require('@/assets/enrichissement-24px-outline.svg'),
        });
    Vue.set(this.vm.itemsMenu, 3,
        {
          name: "Qualite",
          route: "/qualite",
          title: "Mise en qualité",
          hidden: !this.role.app_dig_sirenisation || !this.role.app_dig,
          url: require('@/assets/mise-en-qualite-24px-outline.svg'),
        });
  }

  initUser() {
    this.getUser().then(res => {
      if (res !== true) {
        this.$router.go(0);
      } else {
        panierService.getCurrentBasketFromUser(this.user.id).then(res => {
          this.setCountField(res.data.message.Items.length);
          this.isLoading = false;
        });
      }
    });
    this.getRoles();
    this.handleSelectItem(this.vm.itemsMenu[0]);
  }

  logout() {
    this.isLoading = true;
    authService.logout();
    this.vm.login = false;
  }

  img(value) {
    return require('@/assets/' + value);
  }

  formatNumber(x) {
    return frontService.numberWithSpaces(x);
  }

}
